import React, {useState} from 'react';
import RadioButtons from './RadioButtons';
import './css/TextArea.css';

function TextArea({notesUpdate}) {
    let [showClass, setShowClass] = useState(false),    //toggles text area
        [inputValue, setInputValue] = useState(''),     //state for input
        [color, setColor] = useState('red');           //category selected

    //what happnes when you click the add button
    const addHandler = () => {
        if(!inputValue) return;
        //callback with color and content as argument
        notesUpdate(color, inputValue.slice(), (er) => {
            //if added clear text input
            if(!er) setInputValue('');
            else alert(er);
        });
    }
  
    //sync user input and state
    const inputHandler = (event) => {
        setInputValue(event.target.value);
    }

    //callback for color chosen
    const colorHandler = (color) => {
        setColor(color);
    }

    return (
        <div id="input-container" className={showClass ? "show-input" : "hide-input"}>
            <textarea 
                className={showClass ? "input" : "input hide"} 
                value={inputValue} 
                onChange={inputHandler} 
                placeholder="Enter Diurnal entry"
            />
            <button id="add" className="inputAction" onClick={addHandler}>+</button>
            <RadioButtons 
                showClass={showClass} 
                chosenColor={colorHandler}
            />
            <button 
                id="toggleWidth" 
                className={showClass ? "inputAction"  : "inputAction flip" }  onClick={() => setShowClass(!showClass)}>
                <i className="fa fa-chevron-up" aria-hidden="true"></i>
            </button>
        </div>
    )
}

export default TextArea;